var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTable24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1753 21.136L43.7572 9.86719C43.3001 9.31912 42.6036 9 41.8707 9H14.081C13.3481 9 12.6516 9.31912 12.1945 9.86719L2.52974 21.4297C1.94927 22.1258 1.8356 23.0762 2.23951 23.8786C2.64099 24.6764 3.4875 25.1875 4.41625 25.1875H6.83727V46H11.6745V25.1875H16.5117V34.4375H21.3489V25.1875H34.6512V34.4375H39.4884V25.1875H44.3256V46H49.1628V25.1875H51.5354C51.5524 25.1875 51.5669 25.1875 51.5838 25.1875C52.9189 25.1875 54 24.1538 54 22.875C54 22.1813 53.6807 21.5592 53.1753 21.136ZM44.2869 20.5625H39.4545H34.6222H21.3295H16.4972H11.6648H9.44452L15.2443 13.625H40.7122L46.512 20.5625H44.2869Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTable24);
export default __webpack_public_path__ + "static/media/ico-table-24.cf1666c0.svg";
export { ForwardRef as ReactComponent };